import { PROMPT_TAGS, HPFA_RULES } from "../../../shared/index.js";

/**
 * HPFA (Hyper-Parallel Fractal Architecture) Guidelines
 */
export const HYPER_PARALLEL_ENFORCEMENT = `${PROMPT_TAGS.QUALITY_CHECKLIST.open}
🚀 HYPER-PARALLEL COGNITIVE ARCHITECTURE (HPFA)

To achieve maximum velocity, you MUST leverage these advanced parallel execution patterns:

${HPFA_RULES}

[CRITICAL]: Sequential execution when parallel is possible is a mission failure.
${PROMPT_TAGS.QUALITY_CHECKLIST.close}`;
